import { useEffect } from 'react';

/**
 * Adds a class to the document's body on mount and removes it on unmount.
 *
 * @param {object} className the class to add to the body
 * @return {void}
 */
const useBodyClass = (className) => {
  useEffect(() => {
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  }, []);
};

export default useBodyClass;
